import { lazy, Suspense } from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'
import { CONTRACT_TYPE_BY_SLUG } from '@/pages/contracts/model'

const ContractBuilderPage = lazy(
  () => import('@/pages/contracts/ui/ContractBuilderPage'),
)

export const Route = createFileRoute('/_protected/contracts/$type')({
  // The slug is part of the URL, so an unknown one lands back on the registry
  // instead of rendering an empty document.
  beforeLoad: ({ params }) => {
    if (!(params.type in CONTRACT_TYPE_BY_SLUG)) {
      throw redirect({ to: '/contracts' })
    }
  },
  component: function ContractBuilderRoute() {
    const { type } = Route.useParams()

    return (
      <Suspense fallback={<Loader />}>
        <ContractBuilderPage type={CONTRACT_TYPE_BY_SLUG[type]} />
      </Suspense>
    )
  },
})
